export default {
  sendSGBJ: {
    server: '/sgbj/send',
    method: 'post',
  },
};
